/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Data_OrgInputs */

const da_privacy_data_org = /** @type {(inputs: Privacy_Data_OrgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`**Organisation:** navnet på dit arbejdsrum eller din skole, din rolle, medlemmer og invitationer.`)
};

/** @type {(inputs: Privacy_Data_OrgInputs) => LocalizedString} */
const en_privacy_data_org = da_privacy_data_org;

/**

* @param {Privacy_Data_OrgInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const privacy_data_org = /** @type {((inputs?: Privacy_Data_OrgInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Data_OrgInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_privacy_data_org(inputs)
	return /** @type {LocalizedString} */ ("**Organisation:** navnet på dit arbejdsrum eller din skole, din rolle, medlemmer og invitationer.")
});